export const VOICE_RETRY_MESSAGE =
  "I can help with Joz Worlds. Please try again.";
